export default __webpack_public_path__ + "static/media/usecase-home.f1e6103f.jpg";